import axios from 'axios';

// const API_KEY = process.env.

export default axios.create({
	baseURL: '/export-pdf',
	headers: {
		// 'x-api-key': API_KEY,
	},
});
